var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGerman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "UI / Settingsicons / Flagge / german") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 10,
    cy: 10,
    r: 10
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-/-Settingsicons-/-Flagge-/-german",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-+-Rectangle-+-Rectangle-Mask"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#D8D8D8",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    mask: "url(#mask-2)",
    x: -0.00759606139,
    y: 0,
    width: 20,
    height: 6.52288429
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D80027",
    mask: "url(#mask-2)",
    x: 4.54747351e-13,
    y: 6.52288429,
    width: 20,
    height: 7.04327233
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFDA44",
    mask: "url(#mask-2)",
    x: -0.00759606139,
    y: 13.4771157,
    width: 20,
    height: 6.52288429
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGerman);
export default __webpack_public_path__ + "static/media/german.953f6a044a84129dd77e01381150915b.svg";
export { ForwardRef as ReactComponent };